<template>
    <div
        data-test="message-cloud"
        class="flex flex-col gap-2"
        :class="{
            'items-end': direction === 'outbound' || props.scheduled,
            'items-start': direction === 'inbound',
        }"
    >
        <div v-if="props.unread" class="relative flex items-center justify-center w-full my-4">
            <div class="absolute border-0 border-b border-solid border-amber-300 w-full"></div>
            <vx-badge color="amber" borders size="xs" class="absolute text-center px-3 py-1"> New </vx-badge>
        </div>
        <div
            class="flex flex-col gap-2"
            :class="{
                'items-end': direction === 'outbound' || props.scheduled,
                'items-start': direction === 'inbound',
                'px-4': !props.fullWidth,
                'w-full': props.fullWidth,
            }"
        >
            <div
                class="flex justify-center items-center"
                :class="{
                    'max-w-96': !props.fullWidth,
                    'w-full': props.fullWidth,
                }"
            >
                <span
                    class="text-sm max-w-full text-slate-800 px-4 py-3 border border-solid break-words whitespace-pre-line"
                    data-test="message-cloud-body"
                    :class="{
                        [`${props.outboundColorClasses} rounded-l-lg rounded-tr-lg rounded-br-sm`]:
                            direction === 'outbound' || props.scheduled,
                        [`${props.inboundColorClasses} rounded-r-lg rounded-tl-lg rounded-sm`]: direction === 'inbound',
                        'w-full': props.fullWidth,
                    }"
                    >{{ props.message.body }}</span
                >

                <font-awesome-icon
                    widthAuto
                    v-if="props.scheduled && !hideScheduleEdit"
                    :icon="faMessagePen"
                    size="xl"
                    class="text-sky-500 cursor-pointer ml-2"
                    data-test="schedule-edit-button"
                    @click="emit('editSchedule')"
                >
                </font-awesome-icon>
            </div>
            <message-media
                v-if="props.message.media_url"
                :direction="direction === 'outbound' || props.scheduled ? 'outbound' : 'inbound'"
                :mediaUrl="props.message.media_url"
                :mediaContentType="props.message.media_content_type"
                @mediaPlaceholderClick="emit('mediaPlaceholderClick', $event)"
            ></message-media>
            <message-meta-information
                v-if="props.showDetails"
                :message="props.message"
                :scheduled="props.scheduled"
                :groupsMap="props.groupsMap"
                :isAggregatedView="props.isAggregatedView"
            ></message-meta-information>
        </div>
    </div>
</template>
<script setup>
import { VxBadge } from '@voxie/frontend-components';
import MessageMedia from './MessageMedia.vue';
import MessageMetaInformation from './MessageMetaInformation.vue';
import { faMessagePen } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { computed } from 'vue';

const props = defineProps({
    message: {
        type: Object,
        required: true,
    },
    unread: {
        type: Boolean,
        default: false,
    },
    scheduled: {
        type: Boolean,
        default: false,
    },
    hideScheduleEdit: {
        type: Boolean,
        default: false,
    },
    showDetails: {
        type: Boolean,
        default: true,
    },
    fullWidth: {
        type: Boolean,
        default: false,
    },
    outboundColorClasses: {
        type: String,
        default: 'bg-sky-100 border-sky-200',
    },
    inboundColorClasses: {
        type: String,
        default: 'bg-slate-100 border-slate-200',
    },
    groupsMap: {
        type: Object,
        default: () => new Map(),
    },
    isAggregatedView: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['editSchedule', 'mediaPlaceholderClick']);
const direction = computed(() => props.message?.direction || 'outbound');
</script>
